import React, { FunctionComponent } from 'react';

import { isUndefined } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Rating, Size } from 'core/rating/Rating';
import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';

import 'reviews2/feed/review-yeti/template/field/TemplateFieldSubRating.scss';

export const TemplateFieldSubRating: FunctionComponent<ContextProps> = ({ context }) => {
    const { t } = useTranslation('reviews2');
    const { review } = context;
    const sortedFields = review.sub_ratings;

    if (!sortedFields?.length) {
        return null;
    }

    return (
        <div className="r4e-review-template-field-sub-rating">
            {sortedFields.map((field: any) => {
                const fieldValue = field.rating_value;

                if (isUndefined(fieldValue)) {
                    return null;
                }

                return (
                    <div className="r4e-review-sub-rating-container">
                        <Rating
                            key={field.name}
                            isReadOnly
                            colorFull="ff7f2a"
                            size={Size.XSmall}
                            isDisplayScale={false}
                            selectedValue={fieldValue}
                            className="r4e-review-sub-rating"
                            label={field.name}
                            noRatingText={t('NO_RATING_TEXT')}
                            valueMax={review!.source?.overallRS.overallMax}
                        />
                    </div>
                );
            })}
        </div>
    );
};
